const passwordRecoveryTokenPattern = /(?:^|&)recovery_token=[^&]+/;

/**
 * Netlify Identity's password recovery emails target the site root. Static CMS
 * handles password recovery at /admin/, so preserve the hash token and move
 * the visitor there before the page is rendered.
 */
export const onClientEntry = () => {
  const token = window.location.hash.slice(1);

  if (window.location.pathname === "/" && passwordRecoveryTokenPattern.test(token)) {
    window.location.replace(`/admin/${window.location.hash}`);
  }
};
